import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next'

import AboutPageTranslations from 'Pods/AboutUs/AboutPageTranslations'
import ProfilePageTranslations from 'Pods/Profile/ProfilePage/ProfilePageTranslations'

import GlobalTranslations from 'Translations/GlobalTranslations'
import RailsEn from 'Translations/RailsEn'
import resources from 'Translations/Translations'


i18n
  .use(reactI18nextModule)
  .init({
    resources: {
      ...resources,
      en: {
        ...resources.en,
        rails: {
          ...RailsEn,
        },
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    preload: ['en'],
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })

i18n.addResourceBundle('en', 'global', GlobalTranslations, true, true)
i18n.addResourceBundle('en', 'profile', ProfilePageTranslations, true, true)
i18n.addResourceBundle('en', 'aboutUs', AboutPageTranslations, true, true)

// Non-EN rails bundles are not bundled here: browsers load the active locale
// on demand via Translations/loadLocaleBundle; SSR registers all of them
// statically via Translations/registerAllLocales (packs/server_rendering.js).

export default i18n
